'use strict';

module.exports = function (string) {
  var doc = document;

  if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.webkitMatchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector;
  }

  window.qs = function (selector, scope) {
    return (scope || document).querySelector(selector);
  };

  window.qsa = function (selector, scope) {
    return (scope || document).querySelectorAll(selector);
  };

  var activateResizeHandler = function activateResizeHandler() {
    var win = jQuery(window),
        doc = jQuery('html'),
        resizeClass = 'resize-active',
        burger = jQuery('.header-burger'),
        flag,
        timer;

    var removeClassHandler = function removeClassHandler() {
      flag = false;
      doc.removeClass(resizeClass);
    };

    var windowWidth = jQuery(window).width();

    var resizeHandler = function resizeHandler() {
      if (win.innerWidth() >= 1024) {
        doc.children('body').removeClass('nav-active');
        burger.removeClass('active');
      }

      if (!flag) {
        flag = true;
        doc.addClass(resizeClass);
      }

      clearTimeout(timer);
      timer = setTimeout(removeClassHandler, 500);
    };

    win.on('resize orientationchange', resizeHandler);
  };

  function initBurgerMenu() {
    var burger = jQuery('.header-burger'),
        body = jQuery('body');
    burger.on('click', function (e) {
      e.preventDefault();
      jQuery(this).toggleClass('active');
      body.toggleClass('nav-active');
    });
    jQuery('.header-nav li').on('click', function (e) {
      //e.preventDefault();
      burger.removeClass('active');
      body.removeClass('nav-active');
    });
  }

  function initSlick() {
    jQuery('.clients-slider').slick({
      dots: false,
      arrows: true,
      infinite: true,
      speed: 1000,
      slidesToShow: 2,
      prevArrow: "<button type='button' class='slick-prev slick-arrow'>&lt;</button>",
      nextArrow: "<button type='button' class='slick-next slick-arrow'>&gt;</button>",
      responsive: [{
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  function initAccordion() {
    function toggle(e) {
      var dur = 300;

      if (e.target.matches('.accordion svg') || e.target.matches('.accordion .opener')) {
        e.preventDefault();
        var self = e.target;
        var parent = jQuery(self).parents('.accordion-box');
        parent.find('.slide').slideToggle(dur);
        parent.find('> li').toggleClass('active');
      }
    }

    document.addEventListener('click', toggle, false);
  }

  function smoothScroll() {
    $("a").on('click', function (event) {
      /*            if (this.hash !== "") {
                      console.log(event)
                      event.preventDefault();
                       let hash = this.hash;
                       console.log($(hash).offset().top);
                       $('html, body').animate({
                          scrollTop: $(hash).offset().top - 50
                      }, 800, function(){
                          window.location.hash = hash;
                      });
                  }
                  return false;*/
      if (this.hash) {
        var respond = null;

        var distanceToTop = function distanceToTop(el) {
          return Math.floor(el.getBoundingClientRect().top - 100);
        };

        event.preventDefault();
        var targetID = respond ? respond.getAttribute('href') : this.getAttribute('href');

        if (targetID.match(/\//gi)) {
          var locationHref = window.location.href;
          var addressLink = targetID.substring(0, targetID.indexOf('#'));
          targetID = targetID.replace(addressLink, '');

          if (!addressLink.includes(window.location.origin)) {
            addressLink = window.location.origin + addressLink;
          }

          if (locationHref !== addressLink) {
            window.location.href = addressLink + targetID;
          }
        }

        var targetAnchor = document.querySelector(targetID);
        console.log(targetID);
        if (!targetAnchor) return;
        var originalTop = distanceToTop(targetAnchor);
        window.scrollBy({
          top: originalTop,
          left: 0,
          behavior: 'smooth'
        });
        var checkIfDone = setInterval(function () {
          var atBottom = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - 2;

          if (distanceToTop(targetAnchor) === 0 || atBottom) {
            targetAnchor.tabIndex = '-1';
            targetAnchor.focus();
            window.history.pushState('', '', targetID);
            clearInterval(checkIfDone);
          }
        }, 800);
      }
    });
  }

  function loadMore() {
    if ($('.showroom-list li').length > 4) {
      $('.showroom-btn').on('click', function (event) {
        $('.showroom-list li').toggleClass('active');
        $(this).hide();
      });
    } else {
      $('.showroom-btn').remove();
    }
  }

  function introAnimation() {
    var el = qsa('.intro-content__item'),
        len = el.length,
        j = 0,
        k = 0,
        dur = 300;

    function animate(i) {
      var i = i || 0;

      for (; i < el.length; i++) {
        ;

        (function (x) {
          setTimeout(function () {
            el[x].querySelector('a').classList.add('active');
            setTimeout(function () {
              el[x].querySelector('a').classList.remove('active');
            }, i * (dur / 2));
          }, i * dur);
        })(i);
      }
    }

    function onHover(e) {
      var popup = qsa('.intro-content__item__modal'),
          intro = getCoords(qs('.intro'));

      if (e.target.matches('.intro-content__item--plus')) {
        var popupPos = getCoords(e.target.parentElement.querySelector('.intro-content__item__modal')),
            el = e.target.parentElement.querySelector('.intro-content__item__modal'),
            winRight = document.documentElement.clientWidth - 195,
            winLeft = intro.left,
            winTop = intro.top;

        if (popupPos.top <= winTop) {
          //more than intro
          el.classList.add('reverse-right-bot'); //top

          if (winLeft >= popupPos.left) {
            el.classList.add('reverse-right-bot'); //right
          }

          if (winRight <= popupPos.left) {
            el.classList.remove('reverse-right-bot');
            el.classList.add('reverse-left-bot'); //left
          }
        } else {
          if (winLeft >= popupPos.left) {
            el.classList.add('reverse-right-bot'); //right
          }

          if (winRight <= popupPos.left) {
            el.classList.add('reverse-left-bot'); //left
          }
        }

        qsa('.intro-content__item')[0].querySelector('.intro-content__item__modal').classList.remove('active');
        el.classList.add('active');
      }
    }

    function getCoords(el) {
      var box = el.getBoundingClientRect();
      return {
        top: box.top + pageYOffset,
        left: box.left + pageXOffset
      };
    }

    function onHoverOut(e) {
      if (e.target.matches('.intro-content__item .intro-content__item--plus')) {
        if (e.target.parentElement.querySelector('.intro-content__item__modal').classList.contains('active')) {
          e.target.parentElement.querySelector('.intro-content__item__modal').classList.remove('active');
        }
      }
    }

    window.addEventListener('load', function () {
      animate(0);
      setTimeout(function () {
        if (el[0]) {
          el[0].querySelector('.intro-content__item__modal').classList.add('active');
        }
      }, len * (dur * 2));
      setInterval(function () {
        animate(0);
      }, len * (dur * 2));
    }, false);

    if (el) {
      setTimeout(function () {
        while (len--) {
          el[len].addEventListener('mouseover', onHover, false);
          el[len].addEventListener('mouseout', onHoverOut, false);
        }
      }, len * (dur * 2));
    }
  }

  function changeLangNames() {
    jQuery('.lang-item-en a').text('EN');
    jQuery('.lang-item-de a').text('DE');
    jQuery('.header-lang').removeClass('hidden');
  }

  function initTabs() {
    var wrapper = $("#registration-form");

    if (wrapper) {
      var buttons = $("#registration-form .registration-button button");
      var tabs = $("#registration-form .registration-tab");
      $(buttons).each(function (index) {
        $(this).on("click", function (e) {
          e.preventDefault();
          $("#registration-form .registration-button button.active").removeClass("active");
          $(tabs).hide();
          console.log($(this).data("toggle"));
          $(this).addClass("active");
          $($(this).data("toggle")).show();
        });
      });
    }
  }

  activateResizeHandler();
  initBurgerMenu();
  initSlick();
  initAccordion();
  smoothScroll();
  introAnimation();
  changeLangNames();
  initTabs();
  loadMore(); // *only* if we have anchor on the url

  if (window.location.hash) {
    // smooth scroll to the anchor id
    $('html, body').animate({
      scrollTop: $(window.location.hash).offset().top + 'px'
    }, 1000, 'swing');
  }
};